import { render, staticRenderFns } from "./TheCTA.vue?vue&type=template&id=9b33b34c&"
import script from "./TheCTA.vue?vue&type=script&lang=js&"
export * from "./TheCTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports